import { z } from 'zod';

/**
 * card-payment-sca — 3DS SCA challenge inbox.
 *
 * This flow is NOT an RHF form: there are no user-editable inputs (the only
 * "field" is the Approve/Decline action choice). So `schema.ts` holds zod
 * shapes used to *harden the API responses* (parse + drop malformed items)
 * plus the decision enum used to validate the action payload before the POST.
 * There is no `useForm`, no `defaults` object — see PRD § 6 / § 11 O-5.
 */

export const TimerInfoSchema = z.object({
  id: z.string(),
  /** Epoch seconds when the challenge was raised. */
  challengedAt: z.number(),
  /** Total challenge window, seconds. */
  timeFull: z.number(),
  /** Seconds elapsed since `challengedAt`. */
  timePassed: z.number(),
  /** `max(0, timeFull - timePassed)` seconds. Drives the countdown. */
  timeRemaining: z.number(),
});

export const PendingPaymentSchema = z.object({
  id: z.string(),
  amountNum: z.number(),
  currency: z.string(),
  title: z.string(),
  challengedAt: z.string(),
  transactionChannel: z.string().optional(),
  // Required: an item without a timer can't render the countdown and is
  // treated as non-actionable (filtered out at the api layer).
  timerInfo: TimerInfoSchema,
});

/** The cardholder's choice, sent as the decision endpoint's request body. */
export const DecisionSchema = z.enum(['APPROVED', 'DECLINED']);

export type TimerInfo = z.infer<typeof TimerInfoSchema>;
export type PendingPayment = z.infer<typeof PendingPaymentSchema>;
export type Decision = z.infer<typeof DecisionSchema>;
